//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            showMenuTimeout: null,
        };
    },
    computed: {},
    methods: {
        showSupportMenu() {
            clearTimeout(this.showMenuTimeout);

            this.showMenuTimeout = setTimeout(() => {
                const mouseenterEvent = new Event("mouseenter");
                document.querySelector('#menubar [data-menu="Support"]').dispatchEvent(mouseenterEvent);
                document.querySelector('#menubar [data-menu="Support"] .menu-tab-item').dispatchEvent(mouseenterEvent);
            }, 10);
        },
    },
};
